import {
  Button,
  ButtonType,
  Form,
  FormFieldSize,
  FormGroup,
  Icon,
  MultiSelect,
  SubmitButton
} from '@digicert/dcone-common-ui'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import styles from './AccountAccess.module.scss'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Translate } from 'react-localize-redux'
import { faBuilding, faUser } from '@fortawesome/pro-light-svg-icons'
import { fetchGroups } from 'core/actions/Users.actions'
import { IAccessScope } from 'reducers/Reducers.interfaces'
import { translate } from 'shared/helpers/utils'
import cn from 'classnames'
import { useHistory } from 'react-router-dom'
import { RouterConfig } from 'core/utils/constants'

const AccountAccess = ({ user, fetchGroups, onCancel, onEdit }) => {
  const [options, setOptions] = React.useState([])
  const [groups, setGroups] = React.useState([])
  const [isLoading, setLoading] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    if (user) {
      setGroups(user?.groups.map(group => group.id))
    }
  }, [onCancel])

  useEffect(() => {
    if (user) {
      setGroups(user?.groups.map(group => group.id))
    }
    if (user?.access_scope === IAccessScope.account) {
      fetchGroups(IAccessScope.account.toUpperCase()).then(res => {
        const groupOptions = res.map(group => {
          return {
            value: group.id,
            label: translate(`groups.${group.name}`),
            description: translate(`groups.descriptions.${group.name}`)
          }
        })
        setOptions(groupOptions)
      })
    }
    else {
      fetchGroups(IAccessScope.system.toUpperCase()).then(res => {
        const groupOptions = res.map(group => {
          return {
            value: group.id,
            label: translate(`groups.${group.name}`),
            description: translate(`groups.descriptions.${group.name}`)
          }
        })
        setOptions(groupOptions)
      })
    }
  }, [user])

  const handleMultiSelect = (value): void => {
    setGroups(value)
  }

  const validateMultiSelect = (): any => {
    if (groups?.length === 0) {
      return <Translate id='common.form.validation.required' />
    }
  }

  const renderCustomMultiSelectOption = (option) => {
    return (
      <div className={styles.customMultiSelectOption}>
        <p className={styles.label}>{option.data.label}</p>
        <p className={styles.description}>{option.data.description}</p>
      </div>
    )
  }

  const accountOverview = () => {
    if (user?.accounts?.length > 1 || user.access_scope === IAccessScope.system) {
      history.push(RouterConfig.accounts.table)
    }
    else {
      history.push(RouterConfig.accounts.details(user.accounts[0].id))
    }
  }

  const updateAccountAccess = (event) => {
    setLoading(true)
    onEdit(event, groups, user, setLoading)
  }

  return (
    <div className={styles.accountAccess}>
      <div className={styles.items}>
        <div className={styles.item}>
          <Icon icon={faUser as IconProp} className={styles.icon} />
          <div className={styles.info}>
            <p className={styles.label}><Translate id='common.form.username' /></p>
            <p className={styles.name}>{user.user_name}</p>
          </div>
        </div>
        <div className={styles.item}>
          <Icon icon={faBuilding as IconProp} className={styles.icon} />
          <div className={styles.info}>
            <p className={styles.label}><Translate id='notifications.users.details.digicertAccount' /></p>
            <p className={cn(styles.name, styles.accountName)} onClick={accountOverview}>{user?.accounts?.length > 1 || user.access_scope === IAccessScope.system ? <Translate id='common.form.allAccounts' /> : user?.accounts[0].name + '-' + user?.accounts[0].friendly_identifier}</p>
          </div>
        </div>
      </div>
      <Form onSubmit={(event) => { updateAccountAccess(event) }}>
        <FormGroup>
          <MultiSelect
            help=""
            value={groups}
            placeholder={translate('common.form.select') as string}
            onChange={handleMultiSelect}
            allowClear={true}
            label={translate('manageUser.administrators.userGroup') as string}
            size={FormFieldSize.XL}
            options={options}
            validate={validateMultiSelect}
            optionRender={(option) => (renderCustomMultiSelectOption(option))}
          />
        </FormGroup>
        <div className={styles.formActions}>
          <Button buttonType={ButtonType.SECONDARY} onClick={onCancel}>
            <Translate id='common.form.buttons.cancelBtn' />
          </Button>

          <SubmitButton disabled={isLoading}>
            <Translate id='common.form.buttons.updateAccessBtn' />
          </SubmitButton>
        </div>
      </Form>
    </div>
  )
}

export default connect(null, { fetchGroups })(AccountAccess)
